import { MapPin, Navigation } from 'lucide-react'

function Footer() {
  return (
    <footer className="bg-gray-800 text-white">
      {/* Harita Bölümü - Tam Genişlik */}
      <div className="w-full">
        <div className="relative h-96 w-full">
          <iframe
            src="https://maps.google.com/maps?q=37.156896,37.315530&hl=tr&z=16&output=embed"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Organize Gayrimenkul Konum"
          ></iframe>
          
          {/* Konum Bilgi Overlay */}
          <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm rounded-lg p-3 shadow-lg max-w-xs">
            <div className="flex items-center space-x-2 mb-2">
              <MapPin size={16} className="text-primary-600" />
              <span className="font-semibold text-gray-900 text-sm">Organize Gayrimenkul</span>
            </div>
            <p className="text-xs text-gray-600 leading-relaxed">
              OSB 2.Organize Sanayi Bölgesi<br />
              Şehitkamil / Gaziantep
            </p>
            <a 
              href="https://maps.google.com/?q=37.156896,37.315530"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mt-2 text-xs text-primary-600 hover:text-primary-700 font-medium"
            >
              Google Maps'te Aç →
            </a>
          </div>

          {/* Adrese Git Butonu */}
          <div className="absolute bottom-4 right-4">
            <a 
              href="https://maps.google.com/maps?daddr=37.156896,37.315530&directionsmode=driving"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center bg-primary-600 hover:bg-primary-700 text-white font-semibold py-3 px-6 rounded-lg shadow-lg transition-all duration-300 hover:scale-105 hover:shadow-xl"
            >
              <Navigation size={20} className="mr-2" />
              Adrese Git
            </a>
          </div>
        </div>
      </div>

      {/* Copyright Bölümü */}
      <div className="border-t border-gray-700 py-6 bg-gray-800">
        <div className="container-custom">
          <div className="flex justify-center items-center">
            <p className="text-gray-400 text-sm font-light">
              © 2025 Organize Gayrimankul. Tüm hakları saklıdır.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer 